import { render, staticRenderFns } from "./TaksitlendirmeList.vue?vue&type=template&id=5b798b89"
import script from "./TaksitlendirmeList.vue?vue&type=script&lang=ts"
export * from "./TaksitlendirmeList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports